<template>
  <Modal
    v-if="computer"
    :value="value"
    @hide="hide()"
    title="Computer log"
    :subtitle="subtitle"
  >
    <template slot="body" class="content">
      <p v-if="refreshing">
        <i>Fetching log...</i>
      </p>
      <pre v-show="log">{{ log }}</pre>
    </template>
    <template slot="footer" class="content">
      <div v-if="!refreshing">
        <div
          :disabled="!computer.online"
          class="button is-primary"
          @click="refresh()"
        >
          Refresh
        </div>
        <div
          :disabled="refreshing || !log"
          class="button is-primary"
          @click="download()"
        >
          Download
        </div>
        <div class="button" @click="hide()">Close</div>
      </div>
      <div v-else class="spinner-wrapper center">
        <span class="margin-left-5 spinner"></span>
      </div>
    </template>
  </Modal>
</template>
<script>
import computerHelper from "@/utils/computer";
import { requestLog } from "@/utils/socket";
import { parseAndRound } from "@/utils/string";
import { fromNow, toReadable } from "@/utils/date";
import { postApi } from "@/utils/http";
import { scrollToEnd, downloadFile, getTextUrl } from "@/utils/document";

export default {
  props: {
    value: Boolean,
    computer: Object
  },
  components: {
    Modal: () => import("@/components/main/Modal.vue")
  },
  computed: {
    subtitle() {
      if (this.computer.systemInfo.dpLogSent)
        return `Updated ${fromNow(this.computer.systemInfo.dpLogSent)}`;
      else return null;
    },
    parseAndRound() {
      return str => {
        return parseAndRound(str);
      };
    },
    name() {
      return computer => {
        return computerHelper.getName(computer);
      };
    },
    fromNow() {
      return date => {
        return fromNow(date);
      };
    },
    toIso() {
      return date => {
        return toReadable(date);
      };
    }
  },
  data() {
    return {
      log: null,
      originalDpLogSent: null,
      refreshing: false,
      interval: null
    };
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  created() {
    this.refresh(true);
  },
  methods: {
    async getLog() {
      const res = await postApi("get/computerLog", {
        computerUID: this.computer.uid,
        domainUID: this.$route.params.domainUID
      });

      this.log = res[0];

      this.$nextTick(() => {
        scrollToEnd("modal-body");
      });
    },
    async refresh(force) {
      if (!this.refreshing && (this.computer.online || force)) {
        this.refreshing = true;
        this.originalDpLogSent = this.computer.systemInfo.dpLogSent;

        if (requestLog([this.computer.uid])) {
          const success = await this.waitForLogChange();

          if (success || force) await this.getLog();
        } else
          this.$helpers.notify(
            "Disconnected",
            "No connection to the server, cannot receive log update.",
            "warning",
            -1
          );
      }

      this.refreshing = false;
    },

    waitForLogChange() {
      return new Promise(resolve => {
        this.interval = setInterval(() => {
          if (
            (this.computer.systemInfo &&
              this.originalDpLogSent != this.computer.systemInfo.dpLogSent) ||
            !this.$store.state.socket.connected ||
            !this.computer.online
          ) {
            clearInterval(this.interval);

            if (!this.$store.state.socket.connected) {
              this.$helpers.notify(
                "Disconnected",
                "Connection to the server was interrupted, please try again.",
                "warning"
              );
              resolve(false);
            }

            if (!this.computer.online) {
              this.$helpers.notify(
                "Disconnected",
                "The computer is offline, the log was not updated.",
                "info",
                -1
              );
              resolve(false);
            }

            this.refreshing = false;
            resolve(true);
          }
        }, 1000);
      });
    },

    hide() {
      this.$emit("hide", false);
      this.$emit("input", false);
    },
    download() {
      if (this.log) {
        downloadFile(
          getTextUrl(this.log, "text/plain"),
          `${this.computer.name}_dpLog.txt`
        );
      }
    }
  }
};
</script>
